import { render, staticRenderFns } from "./PdfReader.vue?vue&type=template&id=53266c80&scoped=true"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"
import style0 from "./PdfReader.vue?vue&type=style&index=0&id=53266c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53266c80",
  null
  
)

export default component.exports